module.exports = __webpack_public_path__ + "static/media/source_electricity.ee22a120.png";